import type { MultiBrandConfig } from './types';

// Website 01 — eSIMSUPRA Baseline (locked main brand, default brand).
// Values mirror the original config/brand.ts exactly so that with BRAND_ID
// unset the build output is byte-for-byte identical to before the registry.
export const esimsupra: MultiBrandConfig = {
  id: 'esimsupra',
  status: 'locked',
  siteType: 'storefront',
  positioning: 'Broad authority travel-eSIM marketplace and operational source of truth.',
  theme: {
    mode: 'light',
    defaultDark: 'sunset-vibes',
    defaultLight: 'citrus-burst',
  },
  checkoutEnabled: true,
  legacy: {
    brand: {
      name: 'eSIMSupra',
      displayName: 'eSIMSupra',
      tagline: 'Stay Connected Everywhere — Instant eSIM Activation',
      description:
        'Direct-to-consumer eSIMs for 180+ countries. Instant activation, local rates, 24/7 support.',
      logo: '/images/assets/logo.png',
      logoAlt: 'eSIMSupra Logo',
    },
    contact: {
      email: 'contact@esimsupra.com',
      phone: '',
      phoneFormatted: '',
      whatsapp: '',
      address: 'Available Worldwide',
      supportHours: '24/7 Support',
    },
    website: {
      url: 'https://esimsupra.com',
      domain: 'esimsupra.com',
    },
    social: {
      facebook: '',
      twitter: '',
      instagram: '',
      youtube: '',
      telegram: '',
    },
    resources: {
      compatibilityUrl: '#',
      compatibilityLabel: 'Check Device Compatibility',
    },
    legal: {
      copyrightYear: new Date().getFullYear().toString(),
      copyrightText: `© ${new Date().getFullYear()} eSIMSupra. All rights reserved.`,
    },
    features: {
      count180Countries: '180+ Countries',
      uptimePerformance: 'Partner Networks',
      support247: '24/7 Support',
    },
    ui: {
      theme_palette_selector: true,
    },
  },
  // Default brand: mirror current shared env values (wrangler.toml [vars]) so
  // an unset BRAND_ID reproduces byte-identical output.
  tech: {
    analytics: {
      gtmId: 'GTM-N7H7CZSX',
      ga4Id: 'G-G8T0X64HE6',
      metaPixelId: '2461101087706013',
      // No dedicated Google Ads conversion id/label in the shared env today.
      googleAdsConversionId: undefined,
      googleAdsPurchaseLabel: undefined,
    },
    trustpilot: {
      businessUnitId: undefined, // shared widget falls back to the hardcoded review URL
      locale: 'en-US',
      // Default brand embeds a live TrustBox on the success page, so it loads
      // the Trustpilot bootstrap script + resource hints in the root layout.
      enabled: true,
      reviewDomain: 'esimsupra.com',
    },
    // Default brand loads the cookieless SimpleAnalytics script (pre-consent,
    // DNT-respecting) exactly as before — keeps output byte-identical.
    simpleAnalytics: true,
    stripe: {
      statementDescriptorSuffix: undefined, // shared account default descriptor
      accountId: undefined,
    },
    canonical: {
      domain: 'esimsupra.com',
      url: 'https://esimsupra.com',
      organizationLegalName: 'eSIMSupra',
    },
    llms: {
      tagline: 'Stay Connected Everywhere — Instant eSIM Activation',
      audience: 'International travelers buying prepaid data eSIMs for 180+ countries.',
    },
  },
};

export default esimsupra;
